// extracted by mini-css-extract-plugin
module.exports = {"header":"member-details_header__3s2Zc","title":"member-details_title__FGWy3","description":"member-details_description__hr24U","select":"member-details_select__1nQ6-"};